import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * MypageClientHotlineView のスタイル
 */
export const mypageClientHotlineViewStyle = tv({
    slots: {
        base: ['px-16 py-24 lg:p-32'],
        button: ['mt-24', 'max-w-full'],
        descriptionBox: [
            'flex flex-col items-center',
            'p-16',
            'bg-blue-gray-75',
            'rounded-md',
            'mt-24',
        ],
        descriptionText: [textStyle({ color: 'base', size: 'md' }), 'text-center'],
        linkGroup: ['group', 'mt-16'],
        linkText: [linkTextStyle({ isBold: true, isGroup: true, size: 'md' })],
        list: ['mt-16'],
        listSection: ['mt-40'],
        warningText: ['whitespace-pre-line', 'mt-16'],
    },
});
